<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Relacionamento
                </span>
            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0" style=" margin-left: 10px">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <input #filter placeholder="Buscar Por Nome, Conta ou Assessor" [formControl]="search"
                        (keyup)="onEnter(filter.value)" (keyup.enter)="onEnter(filter.value)">
                    <mat-icon style="cursor: pointer;" (click)="getAll()">
                        search
                    </mat-icon>
                </div>
            </div>
            <!-- / SEARCH -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" >
            <mat-tab-group>
                <mat-tab
                    class="accent title"
                    label="Gestão de Relacionamento"
                    *ngIf="_actions.listGestaoRelacionamento.enabled"
                >
                    <ng-template matTabContent>
                        <app-lista-gestao-relacionamento [search]="search"></app-lista-gestao-relacionamento>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Histórico de Relacionamento" *ngIf="_actions.listRelacionamento.enabled">
                    <ng-template matTabContent>
                        <div class="content">
                            <mat-card>
                                <mat-card-header style="margin-bottom: 20px">
                                    <mat-card-title>Histórico de Relacionamento</mat-card-title>
                                    <button
                                        mat-mini-fab
                                        style=" margin-left: 10px"
                                        matTooltip="Novo Histórico"
                                        (click)="openCadastro()">
                                        <mat-icon>add_circle</mat-icon>
                                    </button>

                                    <button
                                        mat-mini-fab
                                        style=" margin-left: 10px"
                                        matTooltip="Consultar"
                                        (click)="openFiltro()">
                                        <mat-icon>search</mat-icon>
                                    </button>

                                    <button
                                        mat-mini-fab
                                        style=" margin-left: 10px"
                                        matTooltip="Exportar Relacionamento"
                                        (click)="exportarSaldo()">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>
                                </mat-card-header>
                                <mat-card-content>
                                    <ngx-datatable 
                                        #tableRelacionamento 
                                        class='material striped' 
                                        [loadingIndicator]="loadingIndicator"
                                        [columns]="columns" 
                                        [columnMode]="'force'" 
                                        [headerHeight]="50"                       
                                        [footerHeight]="50" 
                                        [rowHeight]="'auto'" 
                                        [rows]='rows'
                                        [limit]="params.per_page"
                                        (sort)="onSort($event)">
                
                                        <ngx-datatable-column name="Data" prop="data_hora_operacao" [sortable]="false" [width]="80">
                                            <ng-template let-rowIndex="rowIndex" let-data_hora_operacao="value" ngx-datatable-cell-template>
                                                {{ data_hora_operacao | date:'dd/MM/yyyy' }}
                                            </ng-template>
                                        </ngx-datatable-column>   
                
                                        <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                                                <span> {{cliente.nome}}</span> <br />
                                                <small>Conta: {{cliente.numero_xp }}</small> <br />
                                                <small>Assessor: {{cliente.assessor.name }}</small>  <br />
                                                <small>Escritório: {{cliente.escritorio.nome_fantasia}}</small>
                                            </ng-template>
                                        </ngx-datatable-column>
                                                                    
                                        <ngx-datatable-column name="Ação" prop="acao" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                {{row.acao.nome}}
                                                <span *ngIf="row.atividade_cliente_id != null">
                                                    <mat-icon 
                                                        color="warn" 
                                                        matTooltip="Resposta de Atividade: (Data: {{row.atividade_cliente.data_hora_atividade  | date:'dd/MM/yyyy'}} | Assunto: {{row.atividade_cliente.atividade.assunto.nome}} ) "
                                                    >
                                                        info
                                                    </mat-icon>
                                                </span>
                                            </ng-template>
                                        </ngx-datatable-column>
                
                                        <ngx-datatable-column name="Observação" prop="observacao" [sortable]="false" [width]="400">
                                            <ng-template let-rowIndex="rowIndex" let-observacao="value" ngx-datatable-cell-template>
                                                {{observacao}}
                                            </ng-template>
                                        </ngx-datatable-column>
                
                                        <ngx-datatable-column name="Responsável" prop="usuario" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-usuario="value" ngx-datatable-cell-template>
                                                {{usuario.name}}
                                            </ng-template>
                                        </ngx-datatable-column>                                       
                
                                        <ngx-datatable-column 
                                            name="Ações" 
                                            prop="row" 
                                            [sortable]="false" 
                                            [width]="80"                            
                                        >
                                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                <button 
                                                    mat-icon-button 
                                                    matTooltip="Alterar Relacionamento" 
                                                    (click)="alterar(row.id)"
                                                    *ngIf='verifyIfDateIsValidToEditRow(row)'
                                                >
                                                    <mat-icon aria-label="Editar Relacionamento">edit</mat-icon>
                                                </button>
                
                                                <button 
                                                    mat-icon-button 
                                                    matTooltip="Visualizar Relacionamento" 
                                                    (click)="visualizar(row.id)"                                   
                                                >
                                                    <mat-icon aria-label="Visualizar Relacionamento">search</mat-icon>
                                                </button>
                                            </ng-template>
                                        </ngx-datatable-column>
                
                                    </ngx-datatable>
                
                                    <div style="padding: 5px 10px">
                                        <mat-paginator 
                                            #paginator
                                            [length]="length"
                                            [pageSize]="pageSize"
                                            [pageSizeOptions]="pageSizeOptions"
                                            (page)="pageEvent($event)">
                                        </mat-paginator>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>                     
                    </ng-template>
                </mat-tab>

                <mat-tab
                    class="accent title"
                    label="Oportunidades"
                    *ngIf="_actions.listOportunidade.enabled"
                >
                    <ng-template matTabContent>
                        <lista-oportunidade-cliente [searchParam]="search"></lista-oportunidade-cliente>
                    </ng-template>
                </mat-tab>

            </mat-tab-group>

         
        </div>
    </div>
</div>

